require('../../vendor/rmts/scoop-os/resources/js/bootstrap.js');

require('vue-moment');

window.Sortable = require('sortablejs');
window.moment = require('moment');
